import { MAX_UCAS_TARIFF } from '@uc/web/shared/data-access';
import { Offset } from '@uc/web/shared/data-models';
import {
	CourseSearchPayload,
	UniversityCourseSearchPayload,
} from '../models/course-search-payload.models';

export const COURSE_SEARCH_DEFAULT_PAYLOAD: Readonly<CourseSearchPayload> = {
	degreeLevel: 'ALL_UNDERGRADUATE',
	tariffMin: 0,
	tariffMax: MAX_UCAS_TARIFF,
	region: null,
	studyMode: null,
	name: null,
	page: 1,
	limit: 20,
	offset: Offset.Off, // 1 - get 20 for current page; 0 - page * 20
};

export const UNIVERSITY_COURSE_SEARCH_DEFAULT_PAYLOAD: Readonly<UniversityCourseSearchPayload> =
	{
		slug: '',
		degreeLevel: 'ALL_UNDERGRADUATE',
		tariffMin: 0,
		tariffMax: MAX_UCAS_TARIFF,
		studyMode: null,
		name: null,
		page: 1,
		limit: 20,
		offset: Offset.Off, // 1 - get 20 for current page; 0 - page * 20
	};

export const UNIVERSITY_REGION_TYPE_MAPPER = {
	'east-midlands': 'EAST_MIDLANDS',
	'east-of-england': 'EAST_OF_ENGLAND',
	london: 'LONDON',
	'north-east-england': 'NORTH_EAST',
	'north-west-england': 'NORTH_WEST',
	'northern-ireland': 'NORTHERN_IRELAND',
	scotland: 'SCOTLAND',
	'south-east-england': 'SOUTH_EAST',
	'south-west-england': 'SOUTH_WEST',
	wales: 'WALES',
	'west-midlands': 'WEST_MIDLANDS',
	'yorkshire-and-the-humber': 'YORKSHIRE_AND_THE_HUMBER',
};

export const STUDY_MODE_TYPE_MAPPER = {
	'full-time': 'FULL_TIME',
	'part-time': 'PART_TIME',
	sandwich: 'SANDWICH',
	distance: 'DISTANCE_ONLINE',
};
